import type { RecipientGroupMinifiedType as ApiRecipientGroupMinifiedType } from 'src/api/generated/touring/types';
import type { RecipientGroupMinifiedType } from '../../types';

export const mapRecipientGroupMinifiedType = (
  api: ApiRecipientGroupMinifiedType
): RecipientGroupMinifiedType => ({
  id: api.id,
  label: api.label,
});
